import {
  Button,
} from '@material-ui/core';
import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import {
  RouteComponentProps,
} from 'react-router';
import * as Yup from 'yup';
import {
  FormField,
} from '../../../components/GeneralCRUDComponent/FormFields/formFields';
import GeneralFormComponent from '../../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import SnackBarComponent from '../../../components/SnackBarComponent/SnackBarComponent';
import {
  translate,
} from '../../../helperFunctions/translation';
import {
  IStatisticsStore,
} from '../../../mobx-store/storeInterfaces/statisticsInterface';
import {
  AuthStore,
} from '../../../mobx-store/stores/authStore';

interface IProps extends WithSnackbarProps {
  history: any;
  match: any;
  statisticsStore: IStatisticsStore;
  authStore: AuthStore;
}

interface IState {
  formFields: FormField[];
  processing: boolean;
}

@inject('statisticsStore')
@inject('authStore')
@observer
class ChangePassword extends Component<IProps & RouteComponentProps, IState> {
  userId = -1;

  pageTitle = '';

  changePasswordFormTitle = '';

  changePasswordSchema: any;

  submitButton: any;

  cancelButton: any;

  constructor(props: IProps & RouteComponentProps) {
    super(props);
    this.state = {
      formFields: this.getFormFields(),
      processing: false,
    };
    this.userId = props.match.params.id;
    this.pageTitle = 'Change Password';
    this.changePasswordFormTitle = 'Change Password Form';
    this.initChangePasswordSchema();
    this.submitButton = this.getSubmitButton();
    this.cancelButton = this.getCancelButton();
  }

  initChangePasswordSchema = () => {
    this.changePasswordSchema = Yup.object().shape({
      newPassword: Yup.string()
        .min(8, translate('loginScreen.passwordValidationMessage'))
        .max(50, 'Too Long!')
        .required('Required'),
      confirmPassword: Yup.string()
        .min(8, translate('loginScreen.passwordValidationMessage'))
        .max(50, 'Too Long!')  
        .required('Required')
        .oneOf([Yup.ref('newPassword')], 'Passwords must match'),
      adminPassword: Yup.string()
        .required('Required'),
    });
  };

  getFormFields = (): FormField[] => [
    {
      name: 'newPassword',
      label: 'New Password',
      type: 'text',
      filedType: 'InputField',
      value: '',
    },
    {
      name: 'confirmPassword',
      label: 'Confirm Password',
      type: 'text',
      filedType: 'InputField',
      value: '',
    },
    {
      name: 'adminPassword',
      label: 'Admin Password',
      type: 'password',
      filedType: 'InputField',
      value: '',
    },
  ];

  handelCancel = (): void => {
    this.props.history.goBack();
  };

  handelSubmit = async (values: any) => {
    this.setState({
      processing: true,
    });
    try {
      if (values.newPassword !== values.confirmPassword) {
        throw 'Passwords don\'t match';
      }
      await this.props.authStore.changePassword(values, this.userId);
      this.props.history.push('/users');
      SnackBarComponent.getInstance().openSnackbar(translate('createdMessage', {
      }), 5000, 'success');
    } catch (error) {
      this.setState({
        processing: false,
      });
      SnackBarComponent.getInstance().openSnackbar(error, 5000, 'error');
    }
  };

  getSubmitButton = () => ({
    title: 'Submit',
    onSubmit: this.handelSubmit,
  });

  getCancelButton = () => ({
    title: 'Cancel',
    onCancel: this.handelCancel,
  });

  render() {
    return (
      <div>
        <GeneralFormComponent
          formTitle={this.changePasswordFormTitle}
          fields={this.state.formFields}
          formSchema={this.changePasswordSchema}
          submitButton={this.submitButton}
          processing={this.state.processing}
          cancelButton={this.cancelButton}
        />
      </div>
    );
  }

  openSnackbar = (message: string, duration: number, status: 'success'|'warning'|'error'|'info') => {
    this.props.enqueueSnackbar(message, {
      autoHideDuration: duration,
      variant: status,
      action: (
        <Button color="default">Dismiss</Button>
      ),
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
      },
    });
  };
}

export default ChangePassword;
